import React, { useEffect, useState } from "react";
import { LANDING_EXAMPLE } from "./landingExamples";

const headers = () => {
  const t = localStorage.getItem("access_token") || localStorage.getItem("token") || "";
  return { "Content-Type": "application/json", Authorization: "Bearer " + t };
};
const nums = (n) => Array.from({ length: n }, (_, i) => i + 1);
const HIDE = "The section is shown only when its title is filled.";
const BTN2 = " (shown only when trader and analyst registration is open)";
const SECTIONS = [
  { title: "Hero (top of the page)", hint: "If the headline is empty, your community name is used.", fields: [
    ["hero.badge", "Badge", 100], ["hero.title1", "Headline, line 1", 80], ["hero.title2", "Headline, line 2 (highlighted)", 80],
    ["hero.text", "Paragraph", 300, true], ["hero.quote", "Highlighted sentence", 100], ["hero.pill", "Small note", 100],
    ...nums(3).map((i) => ["hero.check" + i, "Checkmark " + i, 30]),
    ["hero.btn1", "Main button text", 30], ["hero.btn2", "Second button text" + BTN2, 30], ["hero.note", "Line under the buttons", 120],
  ] },
  { title: "Problem section", hint: HIDE, fields: [
    ["problem.eyebrow", "Small heading", 40], ["problem.title", "Title", 100], ["problem.intro", "Paragraph", 300, true],
    ...nums(4).flatMap((i) => [["problem.bad" + i, "Problem " + i, 120], ["problem.fix" + i, "Answer " + i, 120]]),
  ] },
  { title: "Solution section", hint: HIDE, fields: [
    ["solution.eyebrow", "Small heading", 40], ["solution.title", "Title", 100],
    ...nums(4).flatMap((i) => [["solution.t" + i, "Item " + i + " title", 40], ["solution.d" + i, "Item " + i + " text", 160]]),
  ] },
  { title: "How it works section", hint: HIDE, fields: [
    ["how.eyebrow", "Small heading", 40], ["how.title", "Title", 100],
    ...nums(3).flatMap((i) => [["how.t" + i, "Step " + i + " title", 30], ["how.d" + i, "Step " + i + " text", 200]]),
  ] },
  { title: "Roles section", hint: HIDE, fields: [
    ["roles.eyebrow", "Small heading", 40], ["roles.title", "Title", 100], ["roles.sub", "Subtitle", 200, true],
    ...[["inv", "Card 1"], ["tr", "Card 2"], ["an", "Card 3"]].flatMap(([c, n]) => [
      ["roles." + c + ".head", n + " title (the card is shown only when filled)", 40], ["roles." + c + ".sub", n + " subtitle", 80],
      ...nums(5).map((i) => ["roles." + c + ".b" + i, n + " point " + i, 120]),
    ]),
  ] },
  { title: "Closing call to action", hint: "", fields: [
    ["cta.title", "Title", 80], ["cta.text", "Text", 200, true], ["cta.btn1", "Main button text", 30], ["cta.btn2", "Second button text" + BTN2, 30],
  ] },
  { title: "Footer links", hint: "Optional. Each link must start with https://. The footer text itself is set in the Branding tab.", fields: [
    ["footer.about", "About link", 300], ["footer.terms", "Terms link", 300], ["footer.privacy", "Privacy link", 300], ["footer.risk", "Risk disclosure link", 300],
  ] },
];

const lab = { display: "block", margin: "12px 0 4px", fontSize: 11, fontWeight: 600, textTransform: "uppercase", color: "var(--text-muted)" };
const inp = { padding: "8px 12px", width: "100%", boxSizing: "border-box", borderRadius: 6, border: "1px solid var(--border)", background: "var(--bg-elevated)", color: "var(--text-main)", fontSize: 14, fontFamily: "inherit" };

const PartnerLandingTab = () => {
  const [v, setV] = useState({});
  const [loaded, setLoaded] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    fetch("/api/partner-admin/landing", { headers: headers() })
      .then((r) => r.json())
      .then((d) => { if (d.ok && d.data) setV(d.data.landing && Object.keys(d.data.landing).length > 0 ? d.data.landing : LANDING_EXAMPLE); setLoaded(true); })
      .catch(() => setLoaded(true));
  }, []);

  const set = (k) => (e) => { const val = e.target.value.replace(/[\u0000-\u001f\u007f]+/g, " "); setV((p) => ({ ...p, [k]: val })); };

  const save = () => {
    const out = {};
    Object.keys(v).forEach((k) => { const t = (v[k] || "").trim(); if (t) out[k] = t; });
    setBusy(true); setErr(""); setMsg("");
    fetch("/api/partner-admin/landing", { method: "PUT", headers: headers(), body: JSON.stringify({ landing: out }) })
      .then((r) => r.json())
      .then((d) => { if (d.ok) setMsg("Saved. Open your landing page in a new tab to see it."); else setErr(d.error || "Failed"); })
      .catch(() => setErr("Failed"))
      .finally(() => setBusy(false));
  };

  return (
    <div style={{ maxWidth: 720 }}>
      <h3 style={{ color: "var(--text-main)", marginTop: 0 }}>Landing page</h3>
      <p style={{ color: "var(--text-muted)", fontSize: 14, lineHeight: 1.5 }}>Write the text of your public landing page. Plain text only. The fields start with example text, so edit anything you like. A section is hidden when its title is empty.</p>
      {msg && <div style={{ background: "var(--success)", color: "#fff", padding: "8px 16px", borderRadius: 6, marginBottom: 12, display: "inline-block" }}>{msg}</div>}
      {err && <div style={{ background: "var(--danger)", color: "#fff", padding: "8px 16px", borderRadius: 6, marginBottom: 12, display: "inline-block" }}>{err}</div>}
      {!loaded ? <div style={{ color: "var(--text-muted)" }}>Loading...</div> : (
        <div>
          {SECTIONS.map((s, i) => (
            <details key={s.title} open={i === 0} style={{ marginBottom: 12, padding: "10px 16px", borderRadius: 8, border: "1px solid var(--border)", background: "var(--bg-surface)" }}>
              <summary style={{ cursor: "pointer", fontWeight: 700, color: "var(--text-main)" }}>{s.title}</summary>
              {s.hint && <div style={{ fontSize: 12, color: "var(--text-muted)", marginTop: 6 }}>{s.hint}</div>}
              {s.fields.map(([k, label, max, multi]) => (
                <div key={k}>
                  <label style={lab}>{label}</label>
                  {multi
                    ? <textarea style={{ ...inp, minHeight: 70 }} maxLength={max} value={v[k] || ""} onChange={set(k)} />
                    : <input style={inp} maxLength={max} value={v[k] || ""} onChange={set(k)} />}
                </div>
              ))}
            </details>
          ))}
          <button disabled={busy} onClick={save} style={{ padding: "8px 20px", borderRadius: 6, border: "none", cursor: busy ? "default" : "pointer", fontWeight: 700, fontSize: 13, background: "var(--accent)", color: "#fff" }}>Save</button>
          <button type="button" disabled={busy} onClick={() => { if (window.confirm("Replace all fields with the example text? Click Save afterwards to keep it.")) setV({ ...LANDING_EXAMPLE }); }} style={{ marginLeft: 10, padding: "8px 20px", borderRadius: 6, border: "1px solid var(--border)", cursor: busy ? "default" : "pointer", fontWeight: 700, fontSize: 13, background: "transparent", color: "var(--text-main)" }}>Restore example text</button>
        </div>
      )}
    </div>
  );
};

export default PartnerLandingTab;
